<!-- 页面布局（顶部、内容、底部） 内容页，点击顶部导航菜单获取path，切换内容页，由父组件调用loadModule方法切换-->
<template>
  <router-view :key="$route.fullPath"/>
</template>

<script>
import {useRouter, useRoute} from "vue-router"
import {ref} from "vue"

export default {
  name: "AppBody",
  setup(props) {
    let module = ref(props.module)

    const router = useRouter()
    const route = useRoute()

    if (route.path === '/') {
      router.push('/index')
    }

    let routerQuery = ref({})
    const loadModule = (e) => {
      routerQuery.value.type = e.type

      if (e.sid) {
        routerQuery.value.sid = e.sid
      }

      if (e.id) {
        routerQuery.value.id = e.id
      }
      router.push({path: e.path, query: routerQuery.value})
    }

    return {
      module,
      loadModule,
      routerQuery
    }
  }
}
</script>

<style scoped>
</style>
